const MOBILE_MAX_WIDTH = 700; // same as mobile media query

export const isMobile = () => {
    return window.innerWidth < MOBILE_MAX_WIDTH
}